module.exports = __webpack_public_path__ + "static/media/steemit-min.326a70e9.png";